import { settings } from '@rhim/design';
import { Property } from 'csstype';
import React from 'react';

import { isDefined } from '../utils';

export interface XMiniIconProps extends React.SVGProps<SVGSVGElement> {
  size?: Property.Height;
  fill?: Property.Color;
  title?: string;
  role?: string;
}

export const XMiniIcon: React.FunctionComponent<Readonly<React.PropsWithChildren<XMiniIconProps>>> = ({
  size = '16',
  fill = settings.colors.Primary.Blue_9,
  title,
  role,
  ...rest
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" role={role} {...rest}>
      {isDefined(title) ? <title>{title}</title> : null}
      <path
        fill={fill}
        fillRule="evenodd"
        d="m9.914 8.763 3.293-3.293a.999.999 0 1 0-1.414-1.414L8.5 7.349 5.207 4.056A.999.999 0 1 0 3.793 5.47l3.293 3.293-3.293 3.293a.999.999 0 1 0 1.414 1.414L8.5 10.177l3.293 3.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L9.914 8.763z"
      />
    </svg>
  );
};
